export default function isObject(obj: any): boolean {
  return obj === Object(obj);
}
